import { ImageContent } from "@punks/core"
import React from "react"
import { SanityImg } from "../../../cms/components"
import ConditionalLink from "../../utilities/ConditionalLink"
import classes from "./BrandHeader.module.css"

export interface BrandHeaderProps {
  logo: ImageContent
  logoHeight?: number
  backgroundColor?: string
  textColor?: string
  link?: string
}

const DEFAULT_LOGO_HEIGHT = 82

const BrandHeader = ({
  logo,
  backgroundColor,
  textColor,
  link,
  logoHeight,
}: BrandHeaderProps) => {
  return (
    <ConditionalLink link={link}>
      <div
        className={classes.root}
        style={{
          ["--bg-color" as any]: backgroundColor,
          ["--text-color" as any]: textColor,
        }}
      >
        <SanityImg asset={logo} height={logoHeight ?? DEFAULT_LOGO_HEIGHT} />
      </div>
    </ConditionalLink>
  )
}

export default BrandHeader
